import Logo from "../../../../../../assets/images/pc365-logo.png";

export const PatientConnectLogo: React.FC = () => (
  <img src={Logo} alt="Patient Connect 365 enrollment status" height='44px' />
);
